import { boolean, object, string } from 'yup'

const nameValidation = /^[a-zàâçéèêëîïôûùüÿñæœ -]*$/i

const validateMandatForm = object().shape({
  iban: string()
    .matches(/^[0-9A-Z]{27}$/i, 'Format IBAN incorrect')
    .required('Le champ "IBAN" est obligatoire. '),
  bic: string()
    .matches(/^([0-9A-Z]{8}|[0-9A-Z]{11})$/i, 'Format BIC incorrect')
    .required('Le champ "BIC" est obligatoire. '),
  sepaAccepted: boolean().oneOf([true], 'Veuillez confirmer la souscription au mandat.'),
  firstname: string()
    .matches(nameValidation, 'Le champs "Prénom" contient des caractères invalides')
    .required('Le champ "Prénom du responsable" est obligatoire.'),
  lastname: string()
    .matches(nameValidation, 'Le champs "Nom" contient des caractères invalides')
    .required('Le champ "Nom du responsable" est obligatoire.'),
  captchaValidation: boolean().oneOf([true], 'Vous devez sélectionner la bonne image'),
})

export default validateMandatForm
